/**
 * @fileoverview GET handler for the "/engagement/sql_queries" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementSqlQueries } from "./constants";
import type { SqlQueriesResult } from "./types";

export const getSqlQueries = reactQueryFetcherAdapter(
  engagementSqlQueries,
  (signal: AbortSignal): Promise<SqlQueriesResult> => {
    return fetch("/engagement/sql_queries", "GET", {}, { signal });
  }
);
